/* imports */

/* action types */
export const types = {
	IS_LOADING: 'QR/IS_LOADING',
	IS_READY: 'QR/IS_READY',
	SCAN_SUCCESS: 'QR/SCAN_SUCCESS',
	SCAN_ERROR: 'QR/SCAN_ERROR',
	RESET_STATE: 'QR/RESET_STATE'
};

/* initial state */
export const initialState = {
	isLoading: true,
	error: null,
	pathname: null
};

/* reducer */
export default (state = initialState, action) => {
	switch (action.type) {
		case types.IS_LOADING:
			return { ...state, isLoading: true, error: null, pathname: null };

		case types.IS_READY:
			return { ...state, isLoading: false, error: null, pathname: null };

		case types.SCAN_ERROR:
			return {	...state, isLoading: false, error: action.error, pathname: null };

		case types.SCAN_SUCCESS:
			return { ...state, isLoading: false, error: null, pathname: action.pathname };

		case types.RESET_STATE:
			return initialState;

		default:
			return state;
	}
}

/* action creators */
export const actions = {
	isLoading: () => ({ type: types.IS_LOADING }),
	isReady: () => ({ type: types.IS_READY }),
	scanError: error => ({ type: types.SCAN_ERROR, error }),
	scanSuccess: pathname => ({ type: types.SCAN_SUCCESS, pathname }),

	resetState: () => ({ type: types.RESET_STATE }),
};

export const dispatchActions = {
	resetQRHandler: () => dispatch => dispatch(actions.resetState()),

	handleQRLoad: (error) => {
		return dispatch => {
			dispatch(actions.isReady())
		};
	},

	handleQRData: (data) => {
		return dispatch => {
			/* check for correct QR content */
			try {
				const url = new URL(data);
				if (url.origin.indexOf('stx.world') === -1) throw new Error();
				dispatch(actions.scanSuccess(url.pathname));
			} catch (error) {
				dispatch(actions.scanError(new Error("Fehler beim Scannen. Es handelt sich nicht um einen Sensotix Sticker.")));
			}
		}
	},

	handleQRError: (error) => {
		return dispatch => {
			console.log(error);

			dispatch(actions.scanError(error))
		};
	}
};


// WEBPACK FOOTER //
// ./src/components/home/qrHandler/qrHandlerRedux.jsx